import { Button, Grid, Modal, Typography, Backdrop } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import Box from "@mui/material/Box";

import EmployeeDetailPageStore from "../store/EmployeeDetailPageStore";

interface CheckModalProps {
  pageStore?: EmployeeDetailPageStore;
  title: string;
  content: string;
  isOpen: boolean;
  handleClose: () => void;
  onClickOk: () => void;
  onClickCancel?: () => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "15px",
  paddingTop: "40px",
  paddingBottom: "20px",
  paddingLeft: "20px",
  paddingRight: "20px",
  minWidth: "335px",
};

function CheckModal(props: CheckModalProps) {
  return (
    <Modal
      BackdropComponent={Backdrop}
      BackdropProps={{ onClick: () => {} }}
      open={props.isOpen}
      onClose={props.handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <Grid>
          <Grid>
            <Typography
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "16px",
                textAlign: "center",
                marginBottom: "12px",
                color: "#212121",
              }}
            >
              {props.title}
            </Typography>
            <Typography
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "14px",
                textAlign: "center",
                marginBottom: "30px",
                color: "#6C6B6F",
              }}
            >
              {props.content}
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent={props.onClickCancel ? "space-between" : "center"}
          >
            {props.onClickCancel ? (
              <Grid item>
                <Button
                  sx={{
                    background: "#ffffff",
                    borderRadius: "25px",
                    color: "#000000",
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "16px",
                    padding: "17px 59px",
                    border: "1px solid #dddddd",
                    boxShadow: "none",
                  }}
                  variant="contained"
                  onClick={props.onClickCancel}
                >
                  No
                </Button>
              </Grid>
            ) : (
              <></>
            )}

            <Grid item>
              <Button
                sx={{
                  background: "#2281D0",
                  borderRadius: "25px",
                  color: "#ffffff",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "16px",
                  padding: "17px 59px",
                  boxShadow: "none",
                }}
                variant="contained"
                onClick={props.onClickOk}
              >
                Yes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default observer(CheckModal);
